import { Controller } from '@hotwired/stimulus';
export default class extends Controller {
    static values = {
        hover: Boolean,
    }
    connect() {
        this.dropdown = this.element;
        this.dropdownItems = this.element.querySelector('.dropdown__items');

        this.dropdown.addEventListener('click', (e) => {
            this.toggleDropdown(e);
        })
    }

    toggleDropdown(e) {
        if (this.dropdownItems.contains(e.target)) {
            return;
        }
        this.dropdown.classList.toggle('dropdown__active');
        this.closeAllDropdown();
    }

    closeAllDropdown() {
        const allActiveDropdowns = document.querySelectorAll('.dropdown__active');
        [...allActiveDropdowns].forEach((el)=>{
            if (el !== this.dropdown) {
                el.classList.remove('dropdown__active');
            }
        })
    }
}